(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('[data-track]');
    const slides = [...track.children];
    if (!slides.length) return;
    const dots = [...root.querySelectorAll('[data-dot]')];
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    let active = 0, frame;
    function update() {
      const center = track.getBoundingClientRect().left + track.clientWidth / 2;
      active = slides.reduce((best, slide, i) => {
        const r = slide.getBoundingClientRect(), b = slides[best].getBoundingClientRect();
        return Math.abs(r.left + r.width / 2 - center) < Math.abs(b.left + b.width / 2 - center) ? i : best;
      }, 0);
      dots.forEach((dot, i) => i === active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
      prev.disabled = active === 0;
      next.disabled = active === slides.length - 1;
      root.querySelector('[data-count]').textContent = `${active + 1} / ${slides.length}`;
    }
    function go(i) {
      const slide = slides[Math.max(0, Math.min(slides.length - 1, i))];
      const r = slide.getBoundingClientRect(), t = track.getBoundingClientRect();
      track.scrollTo({left: track.scrollLeft + r.left - t.left - (track.clientWidth - r.width) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    prev.addEventListener('click', () => go(active - 1));
    next.addEventListener('click', () => go(active + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    track.addEventListener('keydown', e => {
      if (e.target !== track) return;
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) {
        e.preventDefault();
        go(e.key === 'Home' ? 0 : e.key === 'End' ? slides.length - 1 : active + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });
    track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive:true});
    new ResizeObserver(update).observe(track);
    root.querySelector('[data-controls]').hidden = false;
    update();
  }
  document.querySelectorAll('[data-tn-highlights]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-tn-highlights]').forEach(init));
})();
